import React from 'react';

const LoadingSpinner = ({ size = 'medium' }) => {
  const sizeClasses = {
    small: 'h-6 w-6',
    medium: 'h-10 w-10',
    large: 'h-14 w-14'
  };

  return (
    <div className="flex items-center justify-center p-6">
      <div className={`relative ${sizeClasses[size]}`}>
        <span className="absolute inset-0 rounded-full border-4 border-red-100" />
        <span className="absolute inset-0 rounded-full border-4 border-transparent border-t-[#DB4444] animate-spin" />
      </div>
    </div>
  );
};

export default LoadingSpinner;
